export default function sortChaptersById(chapterIds, chapters) {
  return chapterIds.map(id => {
    let _id = typeof id === 'string' ? parseInt(id, 10) : id;
    return chapters.find(chapter => {
      let _chapterId =
        typeof chapter.id === 'string' ? parseInt(chapter.id, 10) : chapter.id;
      return _chapterId === _id;
    });
  });
}



// WEBPACK FOOTER //
// ./src/components/exhibition/sortChaptersById.js